<div class="hardware-search-filters">
  <div>
    <app-ice-search-field
      placeholder="Søk etter telefoner"
      [value]="searchText"
      (searchTriggered)="filterChange.emit(createFilterValues(searchForm.value, $event))"
    />
  </div>
  @if (canUseManualRegistration() && isManualRegistrationSupported) {
    <a
      class="register-manually"
      data-testid="manual-registration-link"
      tabindex="0"
      (click)="registerManually.emit()"
      (keydown.enter)="registerManually.emit()"
    >
      Registrer manuelt
    </a>
  }
  @if (isLoadingFilters) {
    <app-spinner />
  } @else {
    <form [formGroup]="searchForm">
      <div class="brand-filters">
        <div class="options-title">Merke</div>
        @for (item of manufacturersFormList; track item.value + $index; let i = $index) {
          <ng-container formArrayName="manufacturers">
            <div [formGroupName]="i">
              <div [ngClass]="{ 'disable-click': isLoadingSearchResults }">
                <mat-checkbox formControlName="selected">
                  <span class="filter-checkbox-text">
                    {{ item.controls.name.value }}
                  </span>
                </mat-checkbox>
              </div>
            </div>
          </ng-container>
        }
      </div>
      <ng-container *appAllowSettings="[DealerClaimType.EquipmentUpgrade]">
        @if (displayCreditCheckForm) {
          <app-extended-credit-check size="small" />
        } @else {
          <div
            class="container"
            [ngClass]="
              hasPerformedDetailedCreditCheck() && mobilBytteApproval() === EquipmentUpgradeApprovedState.Approved
                ? 'attention-card-success'
                : 'attention-card-default'
            "
          >
            <div class="mobilbytte-wrapper">
              <div class="mobilbytte-info-container">
                <mat-icon [svgIcon]="IconNames.ice_mobilbytte" />
                <p class="mobilbytte-info">
                  @switch (mobilBytteApproval()) {
                    @case (EquipmentUpgradeApprovedState.NotApproved) {
                      Kredittsjekk ikke godkjent
                      <br />
                      for nye MobilBytte-avtaler
                    }
                    @case (EquipmentUpgradeApprovedState.Undetermined) {
                      Mobilbytte krever
                      <br />
                      utvidet kredittsjekk
                    }
                    @default {
                      Nye MobilBytte-avtaler:
                      <br />
                      Mobiler for inntil
                      <span>
                        {{ equipmentUpgradeAllowance()?.availableCredit | priceFormat: PriceType.OneTime }}
                      </span>
                    }
                  }
                </p>
              </div>
              @if (hasPerformedDetailedCreditCheck() && mobilBytteApproval() === EquipmentUpgradeApprovedState.Approved) {
                <div class="icon-container">
                  <mat-icon [svgIcon]="IconNames.ice_tick_fat" />
                </div>
              }
            </div>
            @if (!hasPerformedDetailedCreditCheck() && hasPerformedAllowanceCheck()) {
              <app-ice-button
                color="outlined"
                size="extra-small"
                testId="extended-credit-check-button"
                (click)="handleCreditCheck()"
              >
                Ta utvidet kredittsjekk
              </app-ice-button>
            }
          </div>
        }
      </ng-container>
      @if (availableForFormList.length > 0) {
        <div class="type-filters">
          <div class="options-title">Tilgjengelig for</div>
          @for (item of availableForFormList; track item.value + $index; let i = $index) {
            <ng-container formArrayName="availableFor">
              <div [formGroupName]="i">
                <div [ngClass]="{ 'disable-click': isLoadingSearchResults }">
                  <mat-checkbox data-testid="mobilbytte-filter-checkbox" formControlName="selected">
                    <span class="filter-checkbox-text">{{ item.controls.name.value }}</span>
                  </mat-checkbox>
                </div>
              </div>
            </ng-container>
          }
        </div>
      }
    </form>
  }
</div>
